module.exports = __webpack_public_path__ + "fonts/AvenirMedium.55152a1.ttf";